import { ICoordPair } from "@/modules/ToolModule/TwoPointsPicker";
import { Component, Vue, Watch } from "vue-property-decorator";
import { laodFromTile, loadFromFits } from "../profile_loader";
import { store } from '@/store';
import { Release } from '@/env';

interface IProfileParams {
  line: ICoordPair
  release: Release
  rerun: string
  filter: string
}

@Component
export class Profile extends Vue {
  line!: ICoordPair
  rerun!: string
  release!: Release
  filter!: string
  nSamples = 512

  x: number[] = []
  y: number[] = []

  private unwatchParams!: () => void

  @Watch('release', { immediate: true })
  onReleaseChange() {
    this.rerun = this.release.defaultRerun
  }

  created() {
    const request = asyncRefresh()
    this.unwatchParams = this.$watch(() => [this.line, this.release, this.rerun, this.filter], () => {
      request(async () => await this.refresh())
    }, { immediate: true })
  }

  beforeDestroy() {
    this.unwatchParams()
  }

  private async refresh() {
    const profile = await laodFromTile(this.line, this.nSamples, this.rerun, this.filter)
    if (this.x.length === 0) {
      this.x = profile.map((p, i) => i)
    }
    this.y = profile
  }

  async downloadAsFits() {
    await store.asyncProgress(`Loading Profile...`, async () =>
      await loadFromFits(this.line, this.release, this.rerun, this.filter),
    )
  }

  static make(params: IProfileParams) {
    return new Profile({
      data: params,
    })
  }
}

function asyncRefresh() {
  let queued: (() => Promise<void>) | undefined
  let active = false

  const flush = async () => {
    if (!active && queued) {
      active = true
      const q = queued
      queued = undefined
      await q()
      active = false
      requestAnimationFrame(flush)
    }
  }

  return (cb: () => Promise<void>) => {
    queued = cb
    flush()
  }
}
